/* ZELVA MARIA | PRIVACY + WELCOME BRIDGE | 2026 */
(() => {
  'use strict';
  const KEY = 'zm_privacy_answer_v2';
  const init = () => {
    const root = document.getElementById('zelva-privacy');
    if (!root || root.dataset.zmInitialized === '1') return;
    root.dataset.zmInitialized = '1';

    const $ = selector => root.querySelector(selector);
    const status = $('#zelva-status-text');
    const panel = $('[data-zelva-preferences]');
    const settings = $('[data-zelva-settings]');
    const buttons = [ $('[data-zelva-accept]'), $('[data-zelva-reject]'), $('[data-zelva-save]') ];
    const choice = {
      analytics: $('[data-consent-analytics]'),
      marketing: $('[data-consent-marketing]'),
      preferences: $('[data-consent-preferences]')
    };
    let busy = false;
    let finished = false;
    let shown = false;

    const api = () => window.Shopify && window.Shopify.customerPrivacy;
    const setStatus = text => { if (status) status.textContent = text; };
    const remembered = () => { try { return localStorage.getItem(KEY) === 'done'; } catch (_) { return false; } };
    const remember = () => { try { localStorage.setItem(KEY, 'done'); } catch (_) {} };
    const signal = () => {
      if (finished) return;
      finished = true;
      window.zmPrivacyComplete = true;
      document.documentElement.dataset.zmPrivacyComplete = 'true';
      document.dispatchEvent(new Event('zm:privacy-complete'));
    };
    const close = (complete = false) => {
      shown = false;
      root.classList.remove('is-visible');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('zelva-privacy-open');
      if (complete) signal();
    };
    const show = () => {
      if (shown) return;
      shown = true;
      root.classList.remove('is-confirmed');
      root.classList.add('is-visible');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('zelva-privacy-open');
      setStatus('WAITING_FOR_CONSENT');
    };
    const setBusy = value => {
      busy = value;
      buttons.forEach(button => { if (button) button.disabled = value; });
    };
    const alreadyAnsweredInShopify = cp => {
      // Only an actual collected choice counts. shouldShowBanner() alone
      // can be false because of region, so it is not used as proof.
      try {
        if (typeof cp.getTrackingConsent === 'function') {
          const value = cp.getTrackingConsent();
          if (value && value.consentCollected === true) return true;
        }
        if (typeof cp.currentVisitorConsent === 'function') {
          const value = cp.currentVisitorConsent();
          if (value && value.consentCollected === true) return true;
        }
      } catch (error) { console.warn('[ZELVA PRIVACY]', error); }
      return false;
    };
    const loadChoices = cp => {
      try {
        if (typeof cp.currentVisitorConsent !== 'function') return;
        const saved = cp.currentVisitorConsent();
        if (!saved) return;
        Object.keys(choice).forEach(key => {
          if (choice[key]) choice[key].checked = saved[key] === 'yes';
        });
      } catch (error) { console.warn('[ZELVA PRIVACY]', error); }
    };
    const submit = consent => {
      if (busy) return;
      const cp = api();
      if (!cp || typeof cp.setTrackingConsent !== 'function') {
        setStatus('PRIVACY_API_NOT_READY');
        return;
      }
      setBusy(true);
      setStatus('PROCESSING_REQUEST');
      try {
        cp.setTrackingConsent(consent, result => {
          if (result && result.error) {
            console.error('[ZELVA PRIVACY] Consent failure', result.error);
            setStatus('CONSENT_ERROR');
            setBusy(false);
            return;
          }
          remember();
          setStatus('CONSENT_SAVED');
          root.classList.add('is-confirmed');
          window.setTimeout(() => { close(true); setBusy(false); }, 500);
        });
      } catch (error) {
        console.error('[ZELVA PRIVACY] Consent failure', error);
        setStatus('CONSENT_ERROR');
        setBusy(false);
      }
    };
    buttons[0]?.addEventListener('click', () => submit({analytics:true, marketing:true, preferences:true}));
    buttons[1]?.addEventListener('click', () => submit({analytics:false, marketing:false, preferences:false}));
    buttons[2]?.addEventListener('click', () => submit({
      analytics: !!choice.analytics?.checked,
      marketing: !!choice.marketing?.checked,
      preferences: !!choice.preferences?.checked
    }));
    settings?.addEventListener('click', () => {
      if (!panel) return;
      const opening = panel.hidden;
      panel.hidden = !opening;
      settings.textContent = opening ? 'CERRAR CONFIGURACIÓN' : 'CONFIGURAR';
      settings.setAttribute('aria-expanded', String(opening));
      setStatus(opening ? 'CONFIGURING_CONSENT' : 'WAITING_FOR_CONSENT');
    });

    if (remembered()) { close(true); return; }
    const ready = () => {
      const cp = api();
      if (!cp || typeof cp.setTrackingConsent !== 'function') return false;
      loadChoices(cp);
      if (alreadyAnsweredInShopify(cp)) {
        remember();
        close(true);
      } else {
        show();
      }
      return true;
    };
    if (ready()) return;
    const load = () => {
      if (ready()) return true;
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return false;
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {
        if (error || !ready()) {
          console.warn('[ZELVA PRIVACY] Customer Privacy API not available', error);
          setStatus('PRIVACY_API_NOT_READY');
          // Do not claim consent or automatically open the promotion on API failure.
        }
      });
      return true;
    };
    if (load()) return;
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (load() || attempts >= 40) {
        clearInterval(timer);
        if (attempts >= 40) console.warn('[ZELVA PRIVACY] Shopify was not ready');
      }
    }, 250);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
